import { Outlet } from 'react-router';

import ProfileHeader from '@/pages/app/common/ProfileHeader';
import BottomNavigation from '@/pages/app/common/BottomNavigation';
import { BottomSheetManager } from './common/BottomSheetManager';
import useAppStore from '@/shared/store/UseAppStore';

/**
 * 관리자시스템 페이지 모듈을 초기화합니다.
 * @returns Manage Page
 * @author Lian
 */
const AppPage = () => {
  const { isShowBottomNavigation, isShowProfileHeader } = useAppStore();

  return (
    <div className="min-h-screen pb-20">
      {isShowProfileHeader && <ProfileHeader />}
      <Outlet />
      <BottomSheetManager />
      {isShowBottomNavigation && <BottomNavigation />}
    </div>
  );
};

export default AppPage;
